"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
class RtcConnection {
    constructor(userId, config, onMessage, onDisconnected) {
        this.iceCandidates = [];
        this.dataChannel = null;
        this.offerId = null;
        this.answerId = null;
        this.createOffer = () => __awaiter(this, void 0, void 0, function* () {
            if (this.offerId) {
                throw new Error("Offer already set for connection");
            }
            const offerId = this.offerId = uuid_1.v1().toString();
            const dataChannel = this.dataChannel = this.connection.createDataChannel(offerId, { ordered: true });
            this.configureDataChannel(dataChannel);
            const offer = yield this.connection.createOffer();
            yield this.connection.setLocalDescription(offer);
            yield this.waitUntilIceGatheringIsComplete();
            return {
                kind: "offer",
                id: offerId,
                userId: this.userId,
                connectionString: offer.sdp,
                iceCandidates: this.iceCandidates.map(c => JSON.stringify(c)),
                ageSeconds: 0
            };
        });
        this.answerRemoteOffer = (offer) => __awaiter(this, void 0, void 0, function* () {
            if (this.offerId) {
                throw new Error("Offer already set for connection");
            }
            else if (this.answerId) {
                throw new Error("Answer already set for connection");
            }
            yield this.connection.setRemoteDescription({
                sdp: offer.connectionString,
                type: "offer"
            });
            offer.iceCandidates.forEach(c => this.connection.addIceCandidate(JSON.parse(c)));
            const answer = yield this.connection.createAnswer();
            yield this.connection.setLocalDescription(answer);
            this.offerId = offer.id;
            const answerId = this.answerId = uuid_1.v1().toString();
            yield this.waitUntilIceGatheringIsComplete();
            return {
                kind: "answer",
                id: answerId,
                offerId: offer.id,
                userId: this.userId,
                connectionString: answer.sdp,
                iceCandidates: this.iceCandidates.map(c => JSON.stringify(c)),
                ageSeconds: 0
            };
        });
        this.addRemoteAnswer = (answer) => __awaiter(this, void 0, void 0, function* () {
            if (this.offerId !== answer.offerId) {
                return false;
            }
            yield this.connection.setRemoteDescription({
                sdp: answer.connectionString,
                type: "answer"
            });
            answer.iceCandidates.forEach(c => this.connection.addIceCandidate(JSON.parse(c)));
            this.answerId = answer.id;
            return true;
        });
        this.isConnected = () => {
            return this.connection.connectionState === "connected";
        };
        this.sendMessage = (message) => {
            var _a;
            try {
                (_a = this.dataChannel) === null || _a === void 0 ? void 0 : _a.send(message);
            }
            catch (_b) { }
        };
        this.close = () => {
            this.connection.close();
        };
        this.waitUntilIceGatheringIsComplete = () => __awaiter(this, void 0, void 0, function* () {
            yield new Promise(resolve => {
                if (this.connection.iceGatheringState === "complete") {
                    resolve(null);
                }
                // Start a fallback timer which resolves this promise in 1 second so that it cannot stay unresolved forever
                const timeout = setTimeout(() => resolve(null), 1000);
                // Listen for onicegatheringstatechange events and resolve the promise once the ice gathering is complete.
                // At this point this.iceCandidates will contain the complete set of ICE candidates.
                this.connection.addEventListener("onicegatheringstatechange", () => {
                    if (this.connection.iceGatheringState === "complete") {
                        clearTimeout(timeout);
                        resolve(null);
                    }
                });
            });
        });
        this.configureDataChannel = (dataChannel) => {
            dataChannel.binaryType = "arraybuffer";
            dataChannel.onmessage = (e) => this.onMessage(e.data);
        };
        this.userId = userId;
        this.connection = new RTCPeerConnection(config);
        this.onMessage = onMessage;
        this.connection.onicecandidate = (e) => {
            if (e.candidate) {
                this.iceCandidates.push(e.candidate);
            }
        };
        this.connection.onconnectionstatechange = () => {
            console.log(`Connection to user: ${this.userId}. Connection state: ${this.connection.connectionState}`);
            if (this.connection.connectionState === "disconnected" ||
                this.connection.connectionState === "closed" ||
                this.connection.connectionState === "failed") {
                onDisconnected();
            }
        };
        this.connection.ondatachannel = (e) => {
            this.configureDataChannel(e.channel);
            this.dataChannel = e.channel;
        };
        console.log(`Creating connection to ${this.userId}`);
    }
}
exports.default = RtcConnection;
